import type { GridRowSelectionModel, GridTreeNode } from "@mui/x-data-grid-premium";

export const isAutoGeneratedRowNode = (rowNode: GridTreeNode) =>
  (rowNode.type === "group" || rowNode.type === "pinnedRow") && rowNode.isAutoGenerated;

export const isPinnedRowNode = (rowNode: GridTreeNode) =>
  rowNode.type === "pinnedRow" || (rowNode.type === "group" && rowNode.isPinned);

export const isGroupOrPinnedRowNodeType = (rowNode: GridTreeNode) =>
  rowNode.type === "group" || rowNode.type === "pinnedRow";

export const getRowSelectionModelFromIds = (ids: string[]): GridRowSelectionModel => ({
  ids: new Set(ids),
  type: "include",
});

export const getRowSelectionModelFromNumericIds = (ids: number[]): GridRowSelectionModel => ({
  ids: new Set(ids),
  type: "include",
});

export const getSelectedRowIdsFromModel = (model: GridRowSelectionModel): string[] =>
  Array.from(model.ids.values()) as string[];

export const getSelectedNumericRowIdsFromModel = (model: GridRowSelectionModel): number[] =>
  Array.from(model.ids.values()) as number[];

export const GRID_DEFAULT_PAGE_SIZE = 50;
